const OPEN_CLASS = 'is-open';
const VISIBLE_CLASS = 'is-visible';
const MENU_OPEN_CLASS = 'has-menu-open';
const NAV_BREAKPOINT = '(min-width: 64em)';
const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

const isVisible = (el) => el.offsetParent !== null || el.getClientRects().length > 0;

export default function MobileMenu() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const panel = document.querySelector('[data-menu-panel]');
    const overlay = document.querySelector('[data-menu-overlay]');
    const header = document.querySelector('[data-header]');

    if (!toggle || !panel) {
        return;
    }

    let open = false;
    let hiddenSiblings = [];

    const hidePage = () => {
        hiddenSiblings = Array.from(document.body.children).filter(
            (el) => el !== header && el !== overlay && !el.hasAttribute('aria-hidden'),
        );
        hiddenSiblings.forEach((el) => el.setAttribute('aria-hidden', 'true'));
    };

    const restorePage = () => {
        hiddenSiblings.forEach((el) => el.removeAttribute('aria-hidden'));
        hiddenSiblings = [];
    };

    const open_ = () => {
        open = true;
        panel.classList.add(OPEN_CLASS);

        if (header) {
            header.classList.add(MENU_OPEN_CLASS);
        }

        toggle.setAttribute('aria-expanded', 'true');

        if (toggle.dataset.labelClose) {
            toggle.setAttribute('aria-label', toggle.dataset.labelClose);
        }

        document.body.style.overflow = 'hidden';

        if (overlay) {
            overlay.hidden = false;
            requestAnimationFrame(() => overlay.classList.add(VISIBLE_CLASS));
        }

        hidePage();

        const first = panel.querySelector(FOCUSABLE);
        if (first) {
            first.focus();
        }
    };

    const close = ({ focusToggle = true } = {}) => {
        if (!open) {
            return;
        }

        open = false;
        panel.classList.remove(OPEN_CLASS);

        if (header) {
            header.classList.remove(MENU_OPEN_CLASS);
        }

        toggle.setAttribute('aria-expanded', 'false');

        if (toggle.dataset.labelOpen) {
            toggle.setAttribute('aria-label', toggle.dataset.labelOpen);
        }

        document.body.style.overflow = '';

        if (overlay) {
            overlay.classList.remove(VISIBLE_CLASS);
            const hide = () => {
                if (!open) {
                    overlay.hidden = true;
                }
            };
            overlay.addEventListener('transitionend', hide, { once: true });
            setTimeout(hide, 250);
        }

        restorePage();

        if (focusToggle) {
            toggle.focus();
        }
    };

    toggle.addEventListener('click', () => (open ? close() : open_()));

    if (overlay) {
        overlay.addEventListener('click', () => close());
    }

    panel.addEventListener('click', (e) => {
        if (e.target.closest('a')) {
            close({ focusToggle: false });
        }
    });

    document.addEventListener('keydown', (e) => {
        if (!open) {
            return;
        }

        if (e.key === 'Escape') {
            close();
            return;
        }

        if (e.key !== 'Tab') {
            return;
        }

        const items = [toggle, ...Array.from(panel.querySelectorAll(FOCUSABLE)).filter(isVisible)];

        if (items.length < 2) {
            return;
        }

        const first = items[0];
        const last = items[items.length - 1];

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });

    const media = window.matchMedia(NAV_BREAKPOINT);
    const onBreakpoint = (e) => {
        if (e.matches) {
            close({ focusToggle: false });
        }
    };

    if (typeof media.addEventListener === 'function') {
        media.addEventListener('change', onBreakpoint);
    } else {
        media.addListener(onBreakpoint);
    }
}
